<template>
  <div class="ticketaparcado">
      <div v-if="cargando" class="cargando">
            <v-progress-circular
            indeterminate
            color="#2562a4"
          ></v-progress-circular>
      </div>
      <ul v-else v-bind:class = "($store.getters.isFiltroTicketsOpen)?'ticket-list  uf-list go-right':'ticket-list uf-list go-left'">
        <li class="uf-item " v-for="ticket in tickets" :key="ticket.cabecera.msct_uid">
          <div class="ticket" :class="{'op': $store.getters.getOpuid != ticket.cabecera.msct_opuid }">
                <div class="top"></div>
              <div class="wrapper">
                    <div class="header px-2 pt-3">
                      <v-btn icon absolute top right flat class="primary"
                          v-if="($store.getters.getOpuid == ticket.cabecera.msct_opuid) && ((ticket.cabecera.msct_tipo === 1 && semaforoReserva(ticket.cabecera.msct_fecha) == 'red') || ticket.cabecera.msct_tipo === 0 )" 
                          src='@/assets/images/papelera.png' 
                          @click="qDeleteTicket(ticket.cabecera.msct_uid)">
                          <v-icon>delete</v-icon>
                      </v-btn>
                      <span v-if="ticket.cabecera.msct_tipo === 1" :class="['dot', semaforoReserva(ticket.cabecera.msct_fecha)]"></span></div>
                      <div class="dates px-3 pb-2">
                        <div class="mb-2">
                            <strong class="mr-2 text-uppercase green caption lighten-2 white--text px-2 py-1" v-if="ticket.cabecera.msct_tipo === 0">
                              <v-icon small class="mr-1 white--text">local_parking</v-icon> 
                              Ticket APARCADO
                            </strong>
                            <strong class="text-uppercase orange caption white--text px-2 py-1 d-inline-flex align-center" v-else>
                              <v-icon small class="mr-2 no-flex white--text">date_range</v-icon>
                              Reserva
                            </strong>
                        </div>
                        <span> {{ticket.cabecera.msct_id_cliente}}</span>
                        <div class="start d-flex align-center flex-wrap">
                              {{new Date(ticket.cabecera.msct_fecha).toLocaleDateString('es-ES', { year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' })}}
                              <!-- Mostramos el nombre de la tienda con este componente -->
                              <Tienda :opUid="ticket.cabecera.msct_opuid"></Tienda>
                        </div>
                      </div>
                    <v-divider></v-divider>
                    <ul class="px-3">
                      <li v-for="linea in ticket.lineasticket" :key="linea.id" >
                        <LineaTicket :lineaticket="linea" :ref="linea.mslt_uid" :key="linea.id + refreshKey"></LineaTicket>
                      </li>
                    </ul>
                    <!-- TODO: Sacar el total del ticket, tengo que ver como hacer cuando se axtualiza el coste extra -->
                    <div class="unishop-cart-total">
                      <span>Unidades:&nbsp; {{ totalUds(ticket.lineasticket) }}</span>
                      <span>Subtotal:&nbsp; {{ subTotal(ticket.lineasticket) }}</span>
                      <span class="title mt-2"><strong>TOTAL:&nbsp; {{ total(ticket.lineasticket) }}</strong></span>
                    </div>
                    <div class="footer pb-3 px-2">
                        <v-btn flat outline block @click="desaparcarTicket(ticket)"  color="primary">
                          <img size="18px" class="mr-2" src='@/assets/images/ticket-back.svg'>
                          Desaparcar ticket
                        </v-btn>
                    </div>
              </div>
             <div class="bottom"></div>
          </div> 
        </li>
    </ul>
    <div class="no-productos" v-if="tickets.length === 0 && !cargando">
       <v-alert
          :value="true"
          color="primary"
          class="mx-5 primary-color"
          outline
          ><v-icon class="mr-2">search_off</v-icon>{{ noTicketLabel }}
        </v-alert>
    </div>
  </div>
</template>
<script>
import EventBus from '@/plugins/EventBus'
import LineaTicket from '../tickets/LineaTicket';
import Tienda from '../tickets/Tienda';

import { TicketApiService } from '@/api/TicketApiService'
import { Util } from '@/api/Util'

const ticketApiService = new TicketApiService()


const util = new Util()

export default {
  name: 'listaTicketsAparcados',
  components: { LineaTicket, Tienda },
  data () { 
    return {
      id: '',
      dialog: true,
      prodAux : "",
      opUid: this.$store.getters.getOpuid,
      noTicketLabel: "No hay tickets aparcados",
      diasReserva: 0,
      diasReservaExtra: 0,
      cargando: false,
      refreshKey: 0
    };
  },
  computed: {
    tickets () {
      return this.$store.state.ticketsAparcados
    },
    cambiotienda () {
      return this.$store.getters.getOpuid
    },
    hasTicketSearched () {
      return this.$store.state.userInfo.hasTicketSearched
    },
  },
  watch: {
    hasTicketSearched (value) {
      this.init()
    },
    cambiotienda (value) {
      this.opUid = value
      this.init()
    }
  },
  mounted () {
    this.init()
    EventBus.$on('listaTicketsActualizar', () => {
      this.init()
    })
  },
  methods: {
    init() {
      this.getDiasReserva()
      this.$store.state.ticketsAparcados = []
      if (this.$store.state.userInfo.hasTicketSearched !== 0) {
         this.getTicketBy() 
      } else {
         this.getAllTicketAparOrderByOpuid()
      }
    },
    subTotal (lineasticket) {
			let subtotal = 0;
      this.refreshKey;
			lineasticket.forEach(element => {
				subtotal += (element.mslt_precio + element.mslt_coste_extra) * element.mslt_unidades
			},subtotal);
			return this.formatMoney(subtotal);
		},
		total (lineasticket) {
			let total = 0;
      this.refreshKey;
			lineasticket.forEach(element => {
				total += (element.mslt_precio + element.mslt_coste_extra) * element.mslt_unidades
			},total);
			return this.formatMoney(total);
		},
		totalUds (lineasticket) {
			let totalUds = 0;
      this.refreshKey;
			lineasticket.forEach(element => {
				totalUds += element.mslt_unidades
			},totalUds);
			return totalUds;
		},
    getDiasReserva() {
      ticketApiService.getDiasReserva()
      .then(data => {
        // console.log(data)
        this.diasReserva = data.list.ticket_aparcado_dias_reserva
        this.diasReservaExtra = data.list.ticket_aparcado_dias_reserva_extra
      })
      .catch(error => {
        if (error.response.status !== 404) {
          //this.$root.$emit('mostrarAlerta', this.$t('lang.comun.error'), 'error')
          util.mostrarEnConsola('ticketApiService - getDiasReserva', error, 'ERROR')
        }
      })
    },    
    getAllTicketAparOrderByOpuid () {
      this.cargando = true
      ticketApiService.getAllTicketAparOrderByOpuid(this.opUid)
        .then(data => {
          this.$store.state.ticketsAparcados = data.list
          this.cargando = false
        })
        .catch(error => {
          this.$store.state.ticketsAparcados = []
          if (error.response.status !== 204) {
            this.$root.$emit('mostrarAlerta', this.$t('lang.comun.error'), 'error')
            util.mostrarEnConsola('ticketApiService - getAllTicketAparOrderByOpuid', error, 'ERROR')
            this.cargando = false
          }
        })
    },
    qDeleteTicket (cabuid) {
      this.$root.$confirm.open('Borrar', '¿Deseas borrar el ticket?', { color: 'primary' }).then((confirm) => {
        if (confirm) {
          this.borrarTicket(cabuid)
        }
      })
    },
    borrarTicket (cabuid) {
      let cabAux={
        msct_uid: cabuid
      }
      ticketApiService.deleteTicket(cabAux)
        .then(data => {
          this.$store.commit('removeFromTicketsAparcados', cabuid)
          util.mostrarEnConsola('ticketApiService - deleteTicket', data.length, 'OK')
        })
        .catch(error => {
          this.$root.$emit('mostrarAlerta', this.$t('lang.comun.error'), 'error')
          util.mostrarEnConsola('ticketApiService - deleteTicket', error, 'ERROR')
        })
    },
    desaparcarTicket (ticket) {
      this.$root.$confirm.open('', '¿Deseas desaparcar el ticket?', { color: 'primary' }).then((confirm) => {
        if (confirm) {
          // console.log(ticket)
          //let arrayProductos = []
          let borrarTicket = true
          let correcto = true
          ticket.lineasticket.forEach(linea =>{
            correcto = this.$refs[linea.mslt_uid][0].addToCart()
            if (!correcto) {
              borrarTicket = false
            }
          })
          if (borrarTicket) {
            localStorage.setItem('tipoTicket', ticket.cabecera.msct_tipo)
            localStorage.setItem('idClienteTicket', ticket.cabecera.msct_id_cliente)
            if (ticket.cabecera.msct_tipo === 1) {
              localStorage.setItem('fechaTicket', ticket.cabecera.msct_fecha)
            }
            this.borrarTicket(ticket.cabecera.msct_uid)
            this.$store.commit('showTickets', false);
            this.$store.commit('showFiltro', false);
            this.$store.commit('showFiltroTickets', false);
            this.$store.commit('showCarritoModal', true);
            // alert('El ticket esta en el carrito')
          } else {
            this.$root.$emit('mostrarAlerta', this.$t('lang.comun.error'), 'error')
          }
        }
      })
    },
    getTicketBy () {
      var filtro={
        opuid: this.opUid
      }
      if (this.$store.state.userInfo.ticketVendedorSearched !=='') {
        let vendedor = this.$store.state.userInfo.ticketVendedorSearched;
        Object.assign(filtro, {vendedor: vendedor})
      }
      if (this.$store.state.userInfo.ticketClienteSearched !=='') {
        let cliente = this.$store.state.userInfo.ticketClienteSearched;
        Object.assign(filtro, {cliente: cliente})
      }
      if (this.$store.state.userInfo.ticketFechaDesdeSearched !=='') {
        let fechaDesde = this.$store.state.userInfo.ticketFechaDesdeSearched;
        Object.assign(filtro, {fechaDesde: fechaDesde})
      }
      if (this.$store.state.userInfo.ticketFechaHastaSearched !=='') {
        let fechaHasta = this.$store.state.userInfo.ticketFechaHastaSearched;
        Object.assign(filtro, {fechaHasta: fechaHasta})
      }
      if (this.$store.state.userInfo.ticketTipoSearched !=='') {
        let tipo = this.$store.state.userInfo.ticketTipoSearched;
        Object.assign(filtro, {tipo: tipo.id})
      }
      // this.cargando = true
      ticketApiService.findTicket(filtro)
          .then(data => {
            // this.cargando = false
            if (data) {
              this.$store.state.ticketsAparcados=data.data.list
            }
            else {   
             this.$store.state.ticketsAparcados=[]
             util.mostrarEnConsola('ticketApiService - getTicketBy', data.length, 'No hay tickets')
            }
            util.mostrarEnConsola('ticketApiService - getTicketBy', data.length, 'OK')
            
          })
          .catch(error => {
            // this.cargando = false
            this.$store.state.ticketsAparcados=[]
            if (error.response.status !== 404) {
              this.$root.$emit('mostrarAlerta', this.$t('lang.comun.error'), 'error')
              util.mostrarEnConsola('ticketApiService - getTicketBy', error, 'ERROR')
            }
          })
    },
    semaforoReserva(fecha) {
      var fechaAux = new Date(fecha)
      var hoy = new Date()
      fechaAux.setDate(fechaAux.getDate() + parseInt(this.diasReserva))
      if (fechaAux>hoy) {
          return 'green'
      } else {
        fechaAux.setDate(fechaAux.getDate() + parseInt(this.diasReservaExtra))
        if (fechaAux>hoy) {
          return 'orange'
        } else {
          return 'red'
        }
      }
    },
    formatMoney (num) {
      return util.formatMoney(num)
    }
    // hayStock (data) {
    //   let tallaAux = {}
    //   if (data.ean !== '') {
    //     for (var i = 0; i < this.producto.tallas.length; i++) {
    //       if (data.articulo.tallas[i].eans.includes( ean => ean.ean === data.ean )) {
    //         tallaAux = data.articulo.tallas[i]
    //         break
    //       }
    //     }
    //   } else if (data.talla !== '') {
    //     tallaAux = data.articulo.tallas.find( talla => talla.talla === data.talla)
    //   } else if (data.tallaInterna !== '') {
    //     tallaAux = data.articulo.tallas.find( talla => talla.tallaInterna === data.tallaInterna)
    //   }
    //   console.log(tallaAux)
    // },
  }

};
</script>